;(() => {
  if (window.imageBannerVideos) {
    window.imageBannerVideos.initAll()
    return
  }

  const controllers = new WeakMap()

  class ImageBannerVideoController {
    constructor(banner) {
      this.banner = banner
      this.videos = [...banner.querySelectorAll('[data-banner-video]')]
      this.desktopQuery = window.matchMedia('(min-width: 750px)')
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
      this.isNearViewport = !('IntersectionObserver' in window)
      this.sync = this.sync.bind(this)
      this.handleVisibility = this.handleVisibility.bind(this)
      this.handleIntersection = this.handleIntersection.bind(this)

      this.videos.forEach((video) => {
        video.muted = true
        video.playsInline = true
      })

      this.addMediaListener(this.desktopQuery)
      this.addMediaListener(this.reducedMotionQuery)
      document.addEventListener('visibilitychange', this.handleVisibility)

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersection, {
          rootMargin: '200px 0px',
          threshold: 0,
        })
        this.observer.observe(this.banner)
      }

      this.sync()
    }

    addMediaListener(query) {
      if (query.addEventListener) query.addEventListener('change', this.sync)
      else query.addListener(this.sync)
    }

    removeMediaListener(query) {
      if (query.removeEventListener) query.removeEventListener('change', this.sync)
      else query.removeListener(this.sync)
    }

    handleVisibility() {
      if (document.hidden) {
        this.videos.forEach((video) => video.pause())
        return
      }

      this.sync()
    }

    handleIntersection(entries) {
      const entry = entries.find(({ target }) => target === this.banner)
      if (!entry) return

      this.isNearViewport = entry.isIntersecting
      this.sync()
    }

    sync() {
      const motionAllowed = !this.reducedMotionQuery.matches && !document.hidden && this.isNearViewport

      this.videos.forEach((video) => {
        const isVisible = window.getComputedStyle(video).display !== 'none'

        if (motionAllowed && isVisible) {
          const playPromise = video.play()
          if (playPromise) playPromise.catch(() => {})
        } else {
          video.pause()
        }
      })
    }

    destroy() {
      this.videos.forEach((video) => video.pause())
      this.removeMediaListener(this.desktopQuery)
      this.removeMediaListener(this.reducedMotionQuery)
      document.removeEventListener('visibilitychange', this.handleVisibility)
      this.observer?.disconnect()
      controllers.delete(this.banner)
    }
  }

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-image-banner]').forEach((banner) => {
      if (controllers.has(banner) || !banner.querySelector('[data-banner-video]')) return
      controllers.set(banner, new ImageBannerVideoController(banner))
    })
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target))
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-image-banner]').forEach((banner) => controllers.get(banner)?.destroy())
  })

  window.imageBannerVideos = { initAll }
  initAll()
})()
